import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import PropertyHighlights from './components/PropertyHighlights';
import Rooms from './components/Rooms';
import Amenities from './components/Amenities';
import Gallery from './components/Gallery';
import Attractions from './components/Attractions';
import Reviews from './components/Reviews';
import WhyChoose from './components/WhyChoose';
import HouseRules from './components/HouseRules';
import FAQs from './components/FAQs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Handle browser back/forward buttons
    const handlePopState = () => {
      const path = window.location.pathname;
      if (path === '/privacy-policy') {
        setCurrentPage('privacy');
      } else if (path === '/terms-conditions') {
        setCurrentPage('terms');
      } else {
        setCurrentPage('home');
      }
    };

    // Check initial path
    handlePopState();

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Handle navigation
  useEffect(() => {
    const handleNavigation = (e) => {
      const target = e.target.closest('a');
      if (target && (target.getAttribute('href') === '/privacy-policy' || target.getAttribute('href') === '/terms-conditions')) {
        e.preventDefault();
        const page = target.getAttribute('href') === '/privacy-policy' ? 'privacy' : 'terms';
        setCurrentPage(page);
        window.history.pushState({}, '', target.getAttribute('href'));
        window.scrollTo(0, 0);
      }
    };

    document.addEventListener('click', handleNavigation);
    return () => document.removeEventListener('click', handleNavigation);
  }, []);

  if (currentPage === 'privacy') {
    return (
      <div className="App">
        <Navbar />
        <PrivacyPolicy />
        <Footer />
        <button
          onClick={() => {
            setCurrentPage('home');
            window.history.pushState({}, '', '/');
            window.scrollTo(0, 0);
          }}
          className="fixed bottom-8 right-8 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-full shadow-lg transition-all z-50"
        >
          ← Back to Home
        </button>
      </div>
    );
  }

  if (currentPage === 'terms') {
    return (
      <div className="App">
        <Navbar />
        <TermsConditions />
        <Footer />
        <button
          onClick={() => {
            setCurrentPage('home');
            window.history.pushState({}, '', '/');
            window.scrollTo(0, 0);
          }}
          className="fixed bottom-8 right-8 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-full shadow-lg transition-all z-50"
        >
          ← Back to Home
        </button>
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <PropertyHighlights />
      <Rooms />
      <Amenities />
      <Gallery />
      <Attractions />
      {/* <Reviews /> */}
      <WhyChoose />
      <HouseRules />
      <FAQs />
      <Contact />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
